import { getBundledProductsById } from "@NA/Store/Components/BundledProducts/BundledProductsSelector";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByNodeId, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { connect } from "http2";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { ResolveThunks } from "react-redux";
import { ThemeProps, css, withTheme } from "styled-components";
import { bannerButtonGaTagV2 } from "@NA/Utils/GtmUtility";
const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const products = getBundledProductsById(state, ownProps.id);

    return {
        products,
        productCount: products?.length ?? 0,
        errorMessage: null,
    };
};

const mapDispatchToProps = {};

const enum fields {
    categoryName = "categoryName",
    title = "title",
    decs = "decs",
    img = "img",
    shopNowUrl = "shopNowUrl",
    background = "background",
}
interface NameArray {
    name: LinkFieldValue;
}

interface TabModel {
    fields: NameArray;
}

interface StructuredData {
    fields: {
        name: string;
        title: string;
        decs: string;
        img: string;
        shopNowUrl: string;
        background: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.categoryName]: TabModel[];
        [fields.title]: string;
        [fields.decs]: string;
        [fields.img]: string;
        [fields.shopNowUrl]: string;
        [fields.background]: string;
    };
}

type Props = OwnProps &
    WidgetProps &
    HasHistory &
    HasCategoryContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface ShopNowBannerStyles {
    leftTabWrapper?: InjectableCss;
    rightTabWrapper?:InjectableCss;
    mainGridContainer?: GridContainerProps;
    imgGridIitem?: GridItemProps;
    img?: ImgProps;
    textGridContainer?: GridContainerProps;
    textGridIitem?: GridItemProps;
    mainHeading?: TypographyProps;
    subHeading?: TypographyProps;
    linkGridItem?: GridItemProps;
    link?: LinkProps;
}
export const shopNowBannerStyles: ShopNowBannerStyles = {
    leftTabWrapper: {
        css: css`
            margin: 80px 0px 0px 0px;
            padding: 0px 15px 0px 4px;
            @media (min-width: 768px) and (max-width: 1080px) {
                margin: 45px 0px 0px 0px;               
            }
        `,
    },
    rightTabWrapper:{
        css: css`
        height: 160px !important;
        padding:0px;
        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 0px 0px 10px;
                            max-height: 153px;
                        `,
                        css`
                            padding: 0px 0px 0px 10px;
                            max-height: 153px;
                        `,
                        css`
                            max-height: 153px;
                            max-height: 50%;
                        `,
                        null,
                        null,
                    ])}
    `,
    },
    mainGridContainer: {
        css: css`
            height: 160px !important;
            border-radius: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                            height: 110px;
                        `,
                        null,
                        null,
                    ])}
        `,
    },
    imgGridIitem: {
        css: css`
            height: 160px !important;
            padding: 0px 0px 0px 11px;
            border-radius: 5px 0 0 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        null,
                        null,
                    ])}
        `,
    },
    img: {
        css: css`
            border-radius: 5px 0 0 5px;
            width: 100%;
            height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        css`
                            width: 40%;
                            height: 110px;
                            border-radius:0px;
                            object-fit: cover;
                        `,
                        null,
                        null,
                    ])}
        `,
    },
    textGridContainer: {
        css: css`
            height: 100%;
        `,
    },
    textGridIitem: {
        css: css`
            padding: 40px 50px 0px 65px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 160px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px 0px 20px 30px;
                    `,
                    css`
                        padding: 0px 0px 20px 30px;
                    `,
                    css`
                        justify-content: flex-start;
                        align-items: flex-start;
                        height: 110px;
                        padding: 10px 0px 0px 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mainHeading: {
        css: css`
            font-family: 'Nunito Sans', sans-serif;
            font-size: 34px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
            margin-bottom: 4px;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 24px;
                        `,
                        css`
                            font-size: 24px;
                        `,
                        css`
                            font-size: 20px;
                            margin-bottom: 0px;
                        `,
                        null,
                        null,
                    ])}
        `,
    },
    subHeading: {
        css: css`
            font-family: 'Nunito Sans', sans-serif;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 16px;
                        `,
                        css`
                            font-size: 16px;
                        `,
                        css`
                            font-size: 14px;
                        `,
                        null,
                        null,
                    ])}
        `,
    },
    linkGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 160px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-items: center;
                    `,
                    css`
                        align-items: center;
                    `,
                    css`
                        align-items: center;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    link: {
        css: css`
            margin: 25px 0 0 -20px;
            display: block;
            width: 170px;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: ${ADIColors.white};
            padding: 12.5px;
            border-radius: 5px;
            border: solid 1px ${ADIColors.white};
            ${TypographyStyle} {
                color: ${ADIColors.white};
            }
            :hover {
                color: ${ADIColors.white};
            }
            @media (min-width: 768px) and (max-width: 1080px) {
                margin: 0px;
                top: 65px;
                left: 30px;
                position: absolute;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 7px 10px;
                        margin: -240px 20px 0px 0px;
                        font-size: 14px;
                        width: 160px;
                    `,
                    css`
                        padding: 7px 10px;
                        margin: -240px 20px 0px 0px;
                        font-size: 14px;
                        width: 160px;
                    `,
                    css`
                        padding: 6px 10px;                        
                        font-size: 14px;
                        width: 160px;                        
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = shopNowBannerStyles;

const ShopNowBanner: React.FC<Props> = ({ history, id, fields, category }) => {
    const [filteredFields, setFilteredFields] = useState<StructuredData | undefined>(undefined);

    useEffect(() => {
        if (category && fields.categoryName) {
            const selectedCategory = fields.categoryName.find(
                item => item.fields.name.value === category.id,
            ) as unknown as StructuredData;
            setFilteredFields(selectedCategory);
        }
    }, [category, fields]);

    if (!filteredFields) {
        return null;
    }

    let backgroundStyle: any = {
        backgroundColor: filteredFields.fields.background,
    };

    if (filteredFields.fields.background) {
        if (!filteredFields.fields.background.includes("#")) {
            styles.textGridContainer = {
                css: css`
                    height: 100%;
                    background-image: url(${filteredFields.fields.background});
                    border-radius:0 5px 5px 0;
                    background-size: 100% 100%;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                            margin: -96px -90px -71px 317px;
                            height: 82%;
                        `,
                        null,
                        null,
                    ])}
                `,
            };
        } else {
            styles.textGridContainer = {
                css: css`
                    height: 100%;
                    background-color: ${filteredFields.fields.background};
                    border-radius:0 5px 5px 0;
                    background-size: 100% 100%;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                        `,
                        css`
                            border-radius:0px;
                            margin: -96px -90px -71px 317px;
                            height: 82%;
                            > div[class^="GridOffset"] {
                                position: absolute;
                                width:60%;
                            }
                        `,
                        null,
                        null,
                    ])}
                `,
            };
        }
    }

    return (
        <>
            {filteredFields && filteredFields.fields && (
                <StyledWrapper {...styles.leftTabWrapper}>
                    <GridContainer {...styles.mainGridContainer} style={backgroundStyle}>
                        <GridItem width={[12, 12, 12, 5, 5]} {...styles.imgGridIitem}>
                            <Img {...styles.img} src={filteredFields.fields.img} altText={""} />
                        </GridItem>
                        <GridItem width={[12, 12, 12, 7, 7]} {...styles.rightTabWrapper}>
                            <GridContainer {...styles.textGridContainer}>
                                <GridItem width={[12, 12, 12, 8, 8]} {...styles.textGridIitem}>
                                    <Typography variant="h2" {...styles.mainHeading}>
                                        {filteredFields.fields.title}
                                    </Typography>
                                    <Typography variant="h3" {...styles.subHeading}>
                                        {filteredFields.fields.decs}
                                    </Typography>
                                </GridItem>
                                <GridItem width={[12, 12, 12, 4, 4]} {...styles.linkGridItem}>
                                    <Link href={filteredFields.fields.shopNowUrl} {...styles.link} data-ga-promo= {bannerButtonGaTagV2("Shop Now")}>
                                        {translate("Shop Now")}
                                    </Link>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(ShopNowBanner),
    definition: {
        group: "Common",
        displayName: "ADI Shop Now Banner",
        fieldDefinitions: [
            {
                name: fields.categoryName,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        name: { type, value },
                    } = item.fields;

                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                validate: (value, item) => {
                    const allCatIds = value.map(item => item.fields.name.value);

                    if (new Set(allCatIds).size !== allCatIds.length) {
                        return "Category Already Exists";
                    } else {
                        return "";
                    }
                },
                fieldDefinitions: [
                    {
                        name: "name",
                        displayName: "Category Name",
                        sortOrder: 0,
                        editorTemplate: "LinkField",
                        isRequired: true,
                        defaultValue: {
                            value: "",
                            type: "Category",
                        },
                        allowUrls: item => {
                            return false;
                        },
                    },
                    {
                        name: "title",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "decs",
                        displayName: "description",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "img",
                        displayName: "Image Path",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "shopNowUrl",
                        displayName: "Button Redirect URL",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "background",
                        displayName: "Backgroud URL Or Color",
                        editorTemplate: "TextField",
                        defaultValue: "#f56800",
                        tooltip: "use # for background color ex: #f56800",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
